<template>
  <footer>
    <div class="chat-trigger">
      <Button
        v-if="!isChatOpen"
        type="primary"
        style="width: 44px"
        @click="isChatOpen = true"
      >
        <Message />
      </Button>
      <!-- <Chat :is-open="isChatOpen" @close="isChatOpen = false" /> -->
      <component
        :is="chat.component"
        :is-open="isChatOpen"
        @close="isChatOpen = false"
      />
    </div>
    <GradientList />
  </footer>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import GradientList from "@/components/icons/GradientList.vue"
import Button from "@/components/uikit/Button.vue"
import { Message } from "@/components/icons"
import Chat from "@/components/chat/desktop/index.vue"
import AdminChat from "../chat/desktop/Admin/AdminChat.vue"
import ModeratorChat from "../chat/desktop/Moderator/ModeratorChat.vue"
export default defineComponent({
  name: "FooterComponent",
  components: {
    GradientList,
    Button,
    Message,
    AdminChat,
    ModeratorChat,
    Chat,
  },
  data() {
    return {
      isChatOpen: false,
    }
  },
  computed: {
    chat() {
      if (this.$route.path.startsWith("/admin")) {
        return {
          component: AdminChat,
          opened: false,
        }
      }

      if (this.$route.path.startsWith("/moderator")) {
        return {
          component: ModeratorChat,
          opened: false,
        }
      }

      return {
        component: Chat,
        opened: false,
      }
    },
  },
  watch: {
    chat: {
      handler() {
        this.isChatOpen = this.chat.opened
      },
      immediate: true,
    },
  },
})
</script>
<style lang="scss" scoped>
footer {
  position: relative;
  .chat-trigger {
    z-index: 2;
    position: fixed;
    right: 35px;
    bottom: 20px;
    display: none;
  }
}
</style>
